import { render, staticRenderFns } from "./AddClientes.vue?vue&type=template&id=1f393f6d&scoped=true&"
import script from "./AddClientes.vue?vue&type=script&lang=js&"
export * from "./AddClientes.vue?vue&type=script&lang=js&"
import style0 from "./AddClientes.vue?vue&type=style&index=0&id=1f393f6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f393f6d",
  null
  
)

export default component.exports